export const environment = {
  production: true,
  endpoint:"https://shop.arbame.com"
};
